import React from "react";
import { Grid2 } from "@mui/material";
import { HistoricalQuotesByInvestmentChart } from "@components";
import { FundamentalsCard } from "../FundamentalsCard";
import { DividendsByInvestmentChart } from "../DividendsChart/DividendsByInvestmentChart";
import { GainLossStatisticsLoader } from "../../../investment/details/GainLossStatisticsLoader";
import { RanksAndRisks } from "../RanksAndRisks";
import { TopHoldings } from "../TopHoldings";

export interface Props {
  investmentId: number;
  isin: string;
  areDividendsPresent?: boolean;
}

export const FundFundamentalsByInvestmentId = ({
  isin,
  investmentId,
  areDividendsPresent = false,
}: Props) => {
  return (
    <Grid2 container spacing={4} width="100%" mt={5}>
      <FundamentalsCard>
        <GainLossStatisticsLoader investmentId={investmentId} />
      </FundamentalsCard>

      {areDividendsPresent && (
        <FundamentalsCard hideFor={["kpmg-germany"]}>
          <DividendsByInvestmentChart investmentId={investmentId} />
        </FundamentalsCard>
      )}

      <FundamentalsCard hideFor={["kpmg-germany"]}>
        <HistoricalQuotesByInvestmentChart investmentId={investmentId} />
      </FundamentalsCard>

      <FundamentalsCard hideFor={["kpmg-germany"]}>
        <RanksAndRisks isin={isin} />
      </FundamentalsCard>

      <FundamentalsCard showFor={["kpmg-germany"]}>
        <TopHoldings isin={isin} />
      </FundamentalsCard>
    </Grid2>
  );
};
